import React from "react";
import { PageHeader } from "./Formats";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="Informativa privacy ai sensi del Regolamento UE 2016/679 (GDPR)." />
      <section className="bg-[#0a0a0a] pb-32">
        <div className="container-x prose-policy max-w-3xl text-[color:var(--txt-secondary)] leading-relaxed space-y-6">
          <h3 className="text-white font-display text-2xl">1. Titolare del trattamento</h3>
          <p>
            Titolare del trattamento è <strong>Scudieri Group S.r.l.</strong>, Viale Lunigiana 8, 20125 Milano,
            P.IVA / CF 09395210967 — email: scudierigroup@gmail.com — PEC: sushicompanysrl1@legalmail.it.
          </p>
          <h3 className="text-white font-display text-2xl">2. Tipologie di dati raccolti</h3>
          <p>Raccogliamo i dati che l'utente fornisce volontariamente tramite il form di contatto: nome, azienda, email, telefono, tipo evento, data, partecipanti, location, messaggio.</p>
          <h3 className="text-white font-display text-2xl">3. Finalità del trattamento</h3>
          <p>I dati sono trattati per rispondere alle richieste, fornire preventivi e gestire l'eventuale rapporto contrattuale.</p>
          <h3 className="text-white font-display text-2xl">4. Base giuridica</h3>
          <p>Esecuzione di misure precontrattuali e legittimo interesse del titolare.</p>
          <h3 className="text-white font-display text-2xl">5. Conservazione</h3>
          <p>I dati sono conservati per il tempo necessario alle finalità e comunque non oltre 24 mesi dall'ultimo contatto, salvo obblighi di legge.</p>
          <h3 className="text-white font-display text-2xl">6. Diritti dell'interessato</h3>
          <p>L'utente può esercitare i diritti previsti dagli artt. 15-22 GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione) scrivendo a scudierigroup@gmail.com.</p>
          <h3 className="text-white font-display text-2xl">7. Cookie</h3>
          <p>
            Il sito utilizza cookie tecnici e, previo consenso, cookie analitici di terze parti. Per il dettaglio consulta la nostra <a href="/cookie" className="link-gold underline underline-offset-4 text-white">Cookie Policy</a>. Puoi modificare le preferenze in qualsiasi momento dal link "Gestisci cookie" nel footer.
          </p>

          <h3 className="text-white font-display text-2xl">8. Reclamo</h3>
          <p>È possibile proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).</p>
        </div>
      </section>
    </div>
  );
}
